import { render } from "./IpraCard.vue?vue&type=template&id=7ceca4b8&scoped=true"
import script from "./IpraCard.vue?vue&type=script&lang=js"
export * from "./IpraCard.vue?vue&type=script&lang=js"

import "./IpraCard.vue?vue&type=style&index=0&id=7ceca4b8&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ceca4b8"]])

export default __exports__